/* eslint-disable react/prop-types */
import React from 'react';
import { Table } from 'react-bootstrap';
import './table.css'; // Import the custom CSS

const DetailsTable = ({
  data,
  columns,
  striped = true,
  borderless = true,
  isTransparent = false,
}) => {

  const tableClassName = `rounded custom-table ${striped ? 'table-striped' : ''} ${borderless ? 'table-borderless' : ''}`;

  return (
    <div className="table-container">
      <Table className={tableClassName} responsive hover>
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th
                key={index}
                className=" text-light font-weight-bold"
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length > 0 &&
            data.map((item, index) => (
              <tr key={index}>
                {columns.map((column, idx) => (
                  <td
                    key={idx}
                    className={`cell ${isTransparent ? 'bg-transparent text-dark' : 'text-light'}`}
                    style={{ width: column.width }}
                  >
                    {column.render(item, index)}
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
};

export default DetailsTable;
